
'use strict';
var angular:angular.IAngularStatic =  require('angular');
import {Injectable, Inject} from 'ng-metadata/core';
import appConfigModule from '../appConfig/appConfig.module';
import { getAutocompleteRequestPunctuationRegex } from '../appConfig/appConfigForward';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/autocompleteInterface';
import { ConfigurationUtil } from '../nddUtils/configurationUtil.service';
import {getVid} from '../appConfig/appConfigForward';

@Injectable()
export class AutoComplete {

    private LETTER_REGEX = '[{\\p{L}}]';
    private PUNCTUATION_REGEX = getAutocompleteRequestPunctuationRegex();


    constructor(@Inject('autoCompleteConfig') private autoCompleteConfig : AutoCompleteConfig,
                @Inject('$http') private $http : ng.IHttpService,
                private configurationUtil: ConfigurationUtil) {

    }

    isAutocompleteEnabledFor(scope) {
        return this.autoCompleteConfig.isEnabled(scope);
    }

    search(queryTerm, scope) {
        if( (!this.configurationUtil.isSuprima() || this.configurationUtil.getFeatureFlag('primo_ve_handle_autocomplete_request_punctuation') )
                && this.PUNCTUATION_REGEX
                && queryTerm.match(new RegExp(this.LETTER_REGEX+'+'+this.PUNCTUATION_REGEX+this.LETTER_REGEX+'+', "u"))){
            return this.punctuationSearch(queryTerm,scope);
        }
        return this.callAutoCompleteRest(queryTerm, scope);
    }

    callAutoCompleteRest(queryTerm: any, scope: any) {
        if (!queryTerm) {
            return [];
        }
        let useNewSuggester = window.appConfig['useNewSuggester'];
        if (useNewSuggester) {
            return this.callNewSuggester(queryTerm, scope);
        }
        let userParams = {
            q: queryTerm
        };
        let params = angular.extend({}, this.autoCompleteConfig.getDefaultParams(scope), userParams);
        return this.$http.jsonp(this.autoCompleteConfig.url,
            {
                jsonpCallbackParam: 'json.wrf',
                params: params
            })
        .then(function(data:{data:{response: PrimoResponse.IAutocompleteSuggestions}}) {
            return data.data.response.docs.map(doc => doc.text)});
    }

    callNewSuggester(queryTerm, scope) {
        let params = {
            q: queryTerm,
            vid: getVid()
        };
        return this.$http.get("/primaws/rest/pub/suggest", {params: params}).then(
            function(data: { data: { response: PrimoResponse.IAutocompleteSuggestions}}) {
                return data.data.response.docs.map(doc => doc.text);
            });
    }

    punctuationSearch(queryTerm, scope) {
        let promisesArray = [];
        promisesArray.push(this.callAutoCompleteRest(queryTerm.replace(new RegExp(this.PUNCTUATION_REGEX, 'gi'),''), scope)); // remove punctuations from query term
        promisesArray.push(this.callAutoCompleteRest(queryTerm.replace(new RegExp(this.PUNCTUATION_REGEX, 'gi'),' '), scope)); // replace punctuations with spaces in query term
        promisesArray.push(this.callAutoCompleteRest(queryTerm, scope)); // query term as it is
        return Promise.all(promisesArray)
            .then((values) => {
                return Array.from(new Set(values.flat().sort((a, b) => {
                    return a.includes(queryTerm) ? -1 : b.includes(queryTerm) ? 1 : a.includes(queryTerm.replace(new RegExp(this.PUNCTUATION_REGEX, 'gi'),' ')) ? -1 : b.includes(queryTerm.replace(new RegExp(this.PUNCTUATION_REGEX, 'gi'),' ')) ? 1 : 0;
                }))) // flat, sort and remove duplicates from the responses array.
            }); 
    }

}
export default [ appConfigModule.name ];




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/autocomplete.service.ts